<template>
  <div class="w-full flex flex-wrap max-w-4xl mx-auto pb-4">
    <div class="flex justify-center w-full mb-4 bg-green-800">
      <div class="flex-shrink-0">
        <datepicker class="current-day-picker" v-model="currentDate"></datepicker>
      </div>
    </div>

    <div class="w-full text-center" v-if="!loading && !items.length">
      You do not have any budgets setup. Please visit <router-link class="text-green-800 underline" to="/settings">Settings</router-link> to get started.
    </div>

    <budget-item
      v-for="item in items"
      :key="item.id"
      :data="item"
      :all-companies="companies"
    ></budget-item>
  </div>
</template>

<script>
import lodash from "lodash"
import { EventBus } from "../events"
import CreateForm from "@/components/CreateForm"
import ReorderForm from "@/components/ReorderForm"
import BudgetItem from "@/components/BudgetItem"
import Datepicker from "vuejs-datepicker"
import moment from "moment"

export default {
  name: "home",
  components: {
    BudgetItem,
    Datepicker,
  },
  data() {
    return {
      loading: false,
      companies: [],
      items: [],
      settings: [],
      currentDate: (function (d) {
        d.setDate(d.getDate() - 1)
        return d
      })(new Date()),
    }
  },
  computed: {},
  watch: {
    currentDate() {
      this.fetch()
    },
  },
  methods: {
    async fetch() {
      this.loading = true
      EventBus.$emit("loading:start")
      await this.axios
        .get("budget/list")
        .then(({ data }) => {
          let companies = lodash.orderBy(data.data, "name")
          this.companies = companies
        })
        .finally(() => {})

      await this.axios
        .get(
          "budget/period?date=" + moment(this.currentDate).format("YYYY-MM-DD")
        )
        .then(({ data }) => {
          this.items = data.periods
        })
        .finally(() => {})

      this.loading = false
      EventBus.$emit("loading:end")
    },
    itemAdded() {
      this.$modal.hide("create-modal")
      this.fetch()
    },
    showCreate() {
      this.$modal.show(
        CreateForm,
        {
          companies: this.companies,
        },
        {
          width: 800,
          height: "auto",
          scrollable: true,
          clickToClose: false,
        }
      )
    },
    showReorder() {
      this.$modal.show(
        ReorderForm,
        {
          existing: this.items,
        },
        {
          width: 800,
          height: "auto",
          scrollable: true,
          clickToClose: false,
        }
      )
    },
  },
  mounted() {
    this.fetch()
    EventBus.$on("fetch-items", () => this.fetch())
  },
}
</script>

<style lang="scss">
.current-day-picker {
  @apply text-black;

  input {
    @apply text-center bg-transparent text-white outline-none cursor-pointer py-2;
  }

  .vdp-datepicker__calendar {
    .cell.selected {
      @apply bg-green-900 text-white;
    }

    .cell:not(.blank):not(.disabled).day:hover {
      @apply border-green-900;
    }

    .cell.selected:hover {
      @apply bg-green-800;
    }
  }
}
</style>
